/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { NewsResultItem } from "layout/homepage/feeds/feed-carousel/news/news-result-item";
import { isArrayNotEmpty } from "cms/utils/empty-exists";

const NewsFeed = (props) => {

    let models = props?.models;

    if (!isArrayNotEmpty(models)) {
        return (<div className="column" />);
    }

    return (
        <>
            {models.map((model, index) => {
                const guid = model?.guid;

                return (
                    <NewsResultItem key={`${guid}${index}`} model={model} />
                );
            })}
        </>
    );
};

export { NewsFeed };
